import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {ContentsDetailsComponent} from './contents-details.component';

const routes: Routes = [
  {path: 'contents/details', component: ContentsDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ContentsDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-details/contents-details-routing.module.ts